import { useQuery } from '@tanstack/react-query';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../../httpClient';
import { concurrentMap } from '../../utils';

export const VEHICLES_BY_IDS_CACHE_KEY = 'searchVehiclesByIds';

export interface VehicleResult {
  id: string;
  vehicle?: ElasticVehicle;
}

interface UseVehiclesByIdsVariables {
  ids?: string[];
}

const useVehiclesByIds = (variables?: UseVehiclesByIdsVariables) => {
  const apiBaseUrl = useApiBaseUrl();
  const enabled = !!variables && Array.isArray(variables.ids) && variables.ids.length > 0;

  const query = useQuery<VehicleResult[]>({
    queryKey: [
      VEHICLES_BY_IDS_CACHE_KEY,
      variables?.ids ? variables.ids.slice().sort().join(',') : '',
    ],
    enabled,
    queryFn: async () => {
      if (!variables?.ids?.length) return [];
      return concurrentMap(variables.ids, 3, async (id) => {
        try {
          const url = `${apiBaseUrl}/api/search/vehicles/${id}`;
          const res = await httpClientGetJson<ElasticVehicle>(url);
          return { id, vehicle: res };
        } catch {
          return { id };
        }
      });
    },
  });

  return query;
};

export default useVehiclesByIds;
